import { render, staticRenderFns } from "./supervisor.vue?vue&type=template&id=16e95d92&scoped=true"
import script from "./supervisor.vue?vue&type=script&lang=js"
export * from "./supervisor.vue?vue&type=script&lang=js"
import style0 from "./supervisor.vue?vue&type=style&index=0&id=16e95d92&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e95d92",
  null
  
)

export default component.exports